import {Type} from 'main.core';
import * as BX from "main";
import { GLOBAL_EVENTS } from "./GlobalEvents";

export class EventBus
{
	constructor(options = {name:'EventBus',isNew:false})
	{
		if (BX.CP.EventBus.__instance&&!options.isNew) {
			return BX.CP.EventBus.__instance;
		}
		this.listeners = {};
		this.name = options.name;
		this.GLOBAL_EVENTS = GLOBAL_EVENTS;
		if (options.isNew) {
			BX.CP.EventBus.__instance = this;
		}
	}

	on(event,callback) {
		if (typeof event!=='string') {
			throw new Error('event will be string type')
		}
		if (!this.listeners[event]) {
			this.listeners[event] = [];
		}
		this.listeners[event].push(callback);
	}

	off(event,callback) {
		this.listeners[event].forEach((item,key)=>{
			if (item===callback) {
				this.listeners[event].splice(key,1)
			}
		})
	}

	emit(event,...args) {
		if (!Object.keys(this.listeners).includes(event)) {
			throw new Error(`Missing event: ${event}`);
		} else {
			this.listeners[event].forEach((listener)=>{
				listener(...args);
			})
		}
	}

	setName(name)
	{
		if (Type.isString(name))
		{
			this.name = name;
		}
	}

	getName()
	{
		return this.name;
	}
}